import { DeviceDetailActionDispatchers } from '../actions';

/**
 * Fires SAILS ready event
 * @param eventName
 * @param actions
 */
export function createSailsReadyEvent (eventName: string, actions: Pick<DeviceDetailActionDispatchers, 'goToBasket'>) {
    const event = new Event(eventName);
    createPublicUpdateFunction(actions);

    document.dispatchEvent(event);
}

function createPublicUpdateFunction (actions: Pick<DeviceDetailActionDispatchers, 'goToBasket'>) {
    const {VF = {}} = (window as any);
    const {SAILS = {}} = VF;

    VF.SAILS = SAILS;
    VF.SAILS.goToBasket = actions.goToBasket;
}
